import axios from 'axios';
import { getKjederegAdminApiUrl } from '../..';
import { SalgFraTilknyttedeGrossistGrupperDto } from './types';

const baseUrl = getKjederegAdminApiUrl() + '/SalgFraTilknyttetGrossistGruppe';

interface SalgFraTilknyttetGrossistGruppeQueryParams {
  take?: number;
  skip?: number;
  enhetId?: number | null;
  enhetsGruppeId?: number | null;
  grossistGruppe?: string | null;
  showIgnorertOnly?: boolean;
  showSameGrossistTilknyttetManyEnhetsgrupperForEnhet?: boolean;
}

interface SalgFraTilknyttetGrossistGruppeCountParams {
  enhetId?: number | null;
  enhetsGruppeId?: number | null;
  grossistGruppe?: string | null;
  showIgnorertOnly?: boolean;
  showSameGrossistTilknyttetManyEnhetsgrupperForEnhet?: boolean;
}

async function getSalgFraTilknyttetGrossistGruppe(
  params: SalgFraTilknyttetGrossistGruppeQueryParams = {},
): Promise<SalgFraTilknyttedeGrossistGrupperDto> {
  const {
    take = 50,
    skip = 0,
    enhetId = null,
    enhetsGruppeId = null,
    grossistGruppe = null,
    showIgnorertOnly = false,
    showSameGrossistTilknyttetManyEnhetsgrupperForEnhet = false,
  } = params;

  const queryParams = new URLSearchParams();

  queryParams.append('take', take.toString());
  queryParams.append('skip', skip.toString());

  if (enhetId !== null) {
    queryParams.append('enhetId', enhetId.toString());
  }

  if (enhetsGruppeId !== null) {
    queryParams.append('enhetsGruppeId', enhetsGruppeId.toString());
  }

  if (grossistGruppe !== null) {
    queryParams.append('grossistGruppe', grossistGruppe);
  }

  queryParams.append('showIgnorertOnly', showIgnorertOnly.toString());
  queryParams.append(
    'showSameGrossistTilknyttetManyEnhetsgrupperForEnhet',
    showSameGrossistTilknyttetManyEnhetsgrupperForEnhet.toString(),
  );

  const response = await axios.get(`${baseUrl}?${queryParams.toString()}`);
  return response.data;
}

async function getSalgFraTilknyttetGrossistGruppeCount(
  params: SalgFraTilknyttetGrossistGruppeCountParams = {},
): Promise<number> {
  const {
    enhetId = null,
    enhetsGruppeId = null,
    grossistGruppe = null,
    showIgnorertOnly = false,
    showSameGrossistTilknyttetManyEnhetsgrupperForEnhet = false,
  } = params;

  const queryParams = new URLSearchParams();

  if (enhetId !== null) {
    queryParams.append('enhetId', enhetId.toString());
  }

  if (enhetsGruppeId !== null) {
    queryParams.append('enhetsGruppeId', enhetsGruppeId.toString());
  }

  if (grossistGruppe !== null) {
    queryParams.append('grossistGruppe', grossistGruppe);
  }

  queryParams.append('showIgnorertOnly', showIgnorertOnly.toString());
  queryParams.append(
    'showSameGrossistTilknyttetManyEnhetsgrupperForEnhet',
    showSameGrossistTilknyttetManyEnhetsgrupperForEnhet.toString(),
  );

  const response = await axios.get(`${baseUrl}/count?${queryParams.toString()}`);
  return response.data;
}

async function ToogleIgnorer(id: number): Promise<void> {
  await axios.put(`${baseUrl}/${id}/toggle-ignorer`);
}

interface OppdaterSistFakturertDatoRequest {
  enhetsgruppeNr: number[];
  lopenummer: number[];
}

interface OppdaterSistFakturertDatoResponse {
  lopenummerAddedToQueue: string[];
}

async function oppdaterSistFakturertDato(
  request: OppdaterSistFakturertDatoRequest,
): Promise<OppdaterSistFakturertDatoResponse> {
  const response = await axios.post(`${baseUrl}/OppdaterSistFakturertDato`, request);
  return response.data;
}

export default {
  getSalgFraTilknyttetGrossistGruppe,
  getSalgFraTilknyttetGrossistGruppeCount,
  ToogleIgnorer,
  oppdaterSistFakturertDato,
};
